var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.path === '/club/invoice/list')?_c('h4',[_vm._v(" *"),_c('span',[_vm._v(_vm._s(_vm.$t('message.playerLockProtection')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }